import React from 'react';
import { IMAGES, scrollToBuy } from '../utils/constants';
const BONUSES = [{
  number: '01',
  title: 'Match Analysis & Player Assessment™',
  image: IMAGES.bonus1,
  lead: 'Analyze what actually happens during training and competition with professional observation and evaluation tools.',
  tags: 'Assessment Sheets · Match Analysis · Error Patterns · Performance Reviews'
}, {
  number: '02',
  title: 'Competitive Pair Development™',
  image: IMAGES.bonus2,
  lead: 'Develop stronger pairs through structured work on roles, communication, positioning, coverage, transitions, and tactical coordination.',
  tags: 'Pair Roles · Communication · Positioning · Coordination · Tactical Patterns'
}, {
  number: '03',
  title: '12-Week Player Development Plans™',
  image: IMAGES.bonus3,
  lead: 'Turn coaching priorities into structured 12-week development programs for individual players and pairs.',
  tags: '12-Week Plans · Objectives · Progressions · Reviews · Adjustments'
}, {
  number: '04',
  title: 'Match Scenario Training Cards™',
  image: IMAGES.bonus4,
  lead: 'Bring realistic match situations directly into training with ready-to-use tactical scenarios and constraints.',
  tags: 'Match Scenarios · Constraints · Scoring · Tactical Cues · Progressions'
}, {
  number: '05',
  title: 'Coaching Feedback & Correction Toolkit™',
  image: IMAGES.bonus5,
  lead: 'Deliver clearer, faster, and more actionable corrections during real training sessions.',
  tags: 'Corrections · Coaching Cues · Feedback · Observation · Court Interventions'
}];
export function Bonuses() {
  return <section aria-labelledby="bonuses-title" className="w-full bg-white px-4 py-8 sm:px-6" data-id="element-19" data-mp="38dw53xvd6wh1">
      <div className="mx-auto max-w-5xl" data-id="element-20" data-mp="33jies9vk7fj8">
        <div className="text-center" data-id="element-21" data-mp="np8buj9azfkb">
          <span className="inline-block rounded-full bg-urgent/15 px-3 py-1 font-head text-[10px] font-semibold uppercase tracking-wider text-urgent sm:text-xs" data-id="element-22" data-mp="no6qnlykpcov">
            Also included at no extra cost
          </span>
          <h2 id="bonuses-title" className="mt-1 font-display text-3xl uppercase leading-none text-charcoal sm:text-4xl" data-id="element-23" data-mp="3cl99x52ljxx9">
            Five Strategic Bonuses
          </h2>
          <p className="mt-1 text-[13px] text-softgray" data-id="element-24" data-mp="3qipc24dv15j7">
            100% included today with your PADEL COACH PRO™ box set.
          </p>
        </div>

        <div className="mt-4 space-y-2.5" data-id="element-25" data-mp="2ttzwikppgp0e">
          {BONUSES.map((bonus, index) => <article key={bonus.number} className="grid items-center gap-3 rounded-xl border border-charcoal/10 bg-ivory p-3.5 md:grid-cols-[200px_1fr]" data-id="element-26" data-mp="2xutkfe35e3ta" data-mpi={index}>
              <button type="button" onClick={scrollToBuy} className={`transition hover:opacity-95 ${index % 2 === 1 ? 'md:order-2' : ''}`} aria-label={`Get ${bonus.title}`} data-id="element-27" data-mp="37kv6k0bxxc5k">
                <img src={bonus.image} alt={`${bonus.title} digital cover`} className="mx-auto w-full max-w-[200px] rounded-lg" loading="lazy" data-id="element-28" data-mp="27jzu5g3vfl6n" />
              </button>
              <div className={index % 2 === 1 ? 'md:order-1' : ''} data-id="element-29" data-mp="1xkitxe7e1zi2">
                <span className="font-head text-[10px] font-semibold uppercase tracking-widest text-urgent" data-id="element-30" data-mp="1tkrvqpfj8h3i">
                  Bonus {bonus.number}
                </span>
                <h3 className="mt-0.5 font-display text-xl uppercase leading-tight text-charcoal sm:text-2xl" data-id="element-31" data-mp="1jufasw3t2lwu">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-[13px] leading-snug text-charcoal" data-id="element-32" data-mp="1evvlclq06rzq">{bonus.lead}</p>
                <p className="mt-1.5 font-head text-[11px] font-semibold uppercase leading-snug tracking-wide text-brand-dark" data-id="element-33" data-mp="19xkaq8rvwdgg">
                  {bonus.tags}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}